import { ReactComponent as UploadIcon } from "assets/images/cloud-add-icon.svg"
import { ReactNode } from "react";

const UploadFile: React.FC<{ children?: ReactNode }> = ({ children }) => {
    return (<div className="cursor-pointer rounded-lg px-4 py-12 flex flex-col items-center justify-center border border-dashed border-[#131141]/40">
        <UploadIcon className="dark:fill-white" />

        {children ?? <>
            <p className="text-center font-[500]">Drag and Drop to Upload</p>
            <p className="text-center text-[#4F5E71]/70">(File type should be either .csv, .svg, .pdf or .xlx)</p>
        </>}
    </div>);
}

export default UploadFile;